interface HelpIconProps {
  className?: string;
}

export const HelpIcon = ({ className }: HelpIconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7.75 7.75C7.75 6.50736 8.75736 5.5 10 5.5C11.2426 5.5 12.25 6.50736 12.25 7.75C12.25 8.87 11.43 9.4 10.75 9.8C10.3 10.06 10 10.45 10 11V11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="10" cy="14.25" r="0.9" fill="currentColor" />
  </svg>
);
